var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Settings", {
    staticClass: "template-settings",
    attrs: {
      region: "left",
      title: _vm.resource("TemplateSettings_Settings_Title")
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.resource("TemplateSettings_Name_Label")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mb-2" },
                [
                  _c("RenamableProperty", {
                    attrs: {
                      name: _vm.name,
                      inputClasses: "form-control",
                      "max-length": 50
                    },
                    on: {
                      "rename-property": function($event) {
                        return _vm.$emit("rename-template", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.resource("TemplateSettings_Modified_Label"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 mb-2" }, [
                _vm._v(
                  "\n                " + _vm._s(_vm.modified) + "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.resource("TemplateSettings_Subject_Label")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mb-2" },
                [
                  _c("RenamableProperty", {
                    attrs: {
                      name: _vm.subject,
                      inputClasses: "form-control",
                      "max-length": 250
                    },
                    on: {
                      "rename-property": function($event) {
                        return _vm.$emit("rename-subject", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(_vm._s(_vm.resource("TemplateSettings_Sender_Label")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mb-2" },
                [
                  _c("RenamableProperty", {
                    attrs: {
                      name: _vm.sender || "",
                      inputClasses: "form-control",
                      "max-length": 150
                    },
                    on: {
                      "rename-property": function($event) {
                        return _vm.$emit("rename-sender", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.resource("TemplateSettings_SenderName_Label"))
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mb-2" },
                [
                  _c("RenamableProperty", {
                    attrs: {
                      name: _vm.senderName || "",
                      inputClasses: "form-control",
                      "max-length": 150
                    },
                    on: {
                      "rename-property": function($event) {
                        return _vm.$emit("rename-sender-name", $event)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.canEditCustomCss
                ? _c(
                    "div",
                    { staticClass: "col-12 mb-2" },
                    [
                      _c("SettingsTextArea", {
                        attrs: {
                          value: _vm.customCss,
                          tooltip: _vm.resource(
                            "TemplateSettings_CustomCss_Tooltip"
                          ),
                          label: _vm.resource(
                            "TemplateSettings_CustomCss_Label"
                          ),
                          rows: 8
                        },
                        on: {
                          input: function($event) {
                            return _vm.$emit("change-custom-css", $event)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-12 mb-2" },
                [
                  _vm.canPickParent
                    ? _c("SettingsDropdown", {
                        attrs: {
                          label: _vm.resource(
                            "TemplateSettings_ParentTemplate_Label"
                          ),
                          options: _vm.templates,
                          textField: "name",
                          valueField: "id"
                        },
                        model: {
                          value: _vm.newParentId,
                          callback: function($$v) {
                            _vm.newParentId = $$v
                          },
                          expression: "newParentId"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }